const MODAL_ROOT_ID = 'nettles-modal-root';
const PWA_CHROME_ROOT_ID = 'nettles-pwa-chrome-root';

/** Portal target outside `body` so `body { zoom: 0.8 }` does not shrink modals. */
export function getModalPortalRoot() {
  if (typeof document === 'undefined') {
    return null;
  }

  let root = document.getElementById(MODAL_ROOT_ID);
  if (!root) {
    root = document.createElement('div');
    root.id = MODAL_ROOT_ID;
    root.setAttribute('data-nettles-modal-root', 'true');
    document.documentElement.appendChild(root);
  }

  return root;
}

/**
 * Portal target for PWA bottom nav / More sheet.
 * Must live on `html` (not `body`) — iOS WebKit treats `position:fixed` inside
 * `body { zoom: 0.8 }` as relative to the zoomed box, leaving a gap under the nav.
 */
export function getPwaChromePortalRoot() {
  if (typeof document === 'undefined') {
    return null;
  }

  let root = document.getElementById(PWA_CHROME_ROOT_ID);
  if (!root) {
    root = document.createElement('div');
    root.id = PWA_CHROME_ROOT_ID;
    root.setAttribute('data-nettles-pwa-chrome-root', 'true');
    document.documentElement.appendChild(root);
  }

  return root;
}
